/* Ryse - Theoric: rodape. Os blocos sanfonados sao <details> nativos.
   No DESKTOP tudo fica aberto e o clique no titulo e desligado (CSS).
   No MOBILE cada bloco respeita seu estado inicial (data-tfoot-abre).
   So reaplica quando CRUZA o breakpoint, pra nao fechar o que a pessoa abriu. */
(function () {
  var MQ = window.matchMedia('(max-width: 989px)');
  var eraMobile = null;

  function aplicar() {
    var mobile = MQ.matches;
    if (mobile === eraMobile) return;
    eraMobile = mobile;

    var blocos = document.querySelectorAll('.tfoot [data-tfoot-abre]');
    for (var i = 0; i < blocos.length; i++) {
      var d = blocos[i];
      d.open = mobile ? d.getAttribute('data-tfoot-abre') === 'sim' : true;
    }
  }

  function iniciar() {
    aplicar();
    if (MQ.addEventListener) MQ.addEventListener('change', aplicar);
    else if (MQ.addListener) MQ.addListener(aplicar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();